import {
  IPurchaseOrder,
  PurchaseOrder,
  PurchaseOrderLine,
  SalesTax,
} from '$models'
import { PurchaseOrderUi } from '../types'

export function convertPurchaseOrderToPurchaseOrderUi(
  purchaseOrder: IPurchaseOrder,
  salesTax: SalesTax[]
) {
  const purchaseOrderUi: PurchaseOrderUi = {
    ...purchaseOrder,
    lines:
      purchaseOrder?.lines?.map((line) => {
        const taxPercent = line.taxPercent
        const matchIndex = salesTax.findIndex((tax) => tax.rate === taxPercent)
        const isCustom = taxPercent != null && matchIndex === -1

        return {
          ...line,
          lineId: line.id ?? crypto.randomUUID(),
          __reorder__: line.itemName ?? '',
          isEstimatedCostLoading: false,
          selectedSalesTax: isCustom
            ? -1
            : matchIndex !== -1
            ? salesTax[matchIndex].sortOrder
            : undefined,
          customTaxRate: isCustom
            ? taxPercent * 100
            : taxPercent != null
            ? taxPercent * 100
            : 0,
        }
      }) ?? [],
  }

  return purchaseOrderUi
}

export function convertPurchaseOrderUiToPurchaseOrder(
  purchaseOrderUi: PurchaseOrderUi
): PurchaseOrder {
  const isCreditRequest = purchaseOrderUi?.creditRequest ?? false

  const lines = purchaseOrderUi?.lines?.map((uiLine, index) => {
    // Destructure and discard UI-only properties
    const {
      lineId: _lineId,
      __reorder__: _reorder,
      isEstimatedCostLoading: _isEstimatedCostLoading,
      selectedSalesTax: _selectedSalesTax,
      customTaxRate: _customTaxRate,
      ...rest
    } = uiLine

    // Apply negative quantities for credit requests
    const baseQuantity = uiLine?.quantityOrdered ?? 0
    const quantity = isCreditRequest ? -Math.abs(baseQuantity) : baseQuantity

    return new PurchaseOrderLine({
      ...rest,
      quantityOrdered: quantity,
      lineOrder: index,
    })
  })

  // Calculate totals with proper signs for credit requests
  const subtotal =
    lines?.reduce((acc, line) => {
      const cost = line.unitCost ?? 0
      const qty = line.quantityReceived ?? 0
      return acc + cost * qty
    }, 0) ?? 0

  const tax =
    lines?.reduce((acc, line) => {
      const cost = line.unitCost ?? 0
      const qty = line.quantityReceived ?? 0
      const taxRate = line.taxPercent ?? 0
      return acc + cost * qty * taxRate
    }, 0) ?? 0

  return new PurchaseOrder({
    ...purchaseOrderUi,
    lines,
    subtotal: subtotal,
    tax: tax,
    total: subtotal + tax,
  })
}
